import { MIN_CARD_PAYMENT, PENCE_IN_POUND } from '../constants'

// Used U. Return highest and lowest price in POUNDS
export const getMaxPriceRange = resources => {
    let pencesPriceHigh = 0
    let pencesPriceLow = 0

    resources.forEach(({ productsV2 }) => {
        productsV2.forEach(({ priceFinal }) => {
            if (priceFinal > pencesPriceHigh) {
                pencesPriceHigh = priceFinal
            }
            if (priceFinal < pencesPriceLow) {
                pencesPriceLow = priceFinal
            }
        })
    })

    return {
        poundsHigh: pencesPriceHigh / PENCE_IN_POUND,
        poundsLow: pencesPriceLow / PENCE_IN_POUND,
    }
}

/* Used U. 
    Calculate difference between price and budget.
    If the budget is not enough, transactionState can go to add budget and pay the difference.
    Return:
    0 if diff < 0, 
    30 if 0 <= diff <= 30 
    or diff if diff > 30
*/
export const calcPayByCard = (price, budget) => {
    const difference = price - budget
    return 0 >= difference ? 0 : difference <= MIN_CARD_PAYMENT ? MIN_CARD_PAYMENT : difference
}

/**
 *  Used for W/M
 * @param {object} values from Formik
 * @param {string} clientId
 * @returns {users: Array<userBody>}
 */
export const parseGiftBudgetBody = ({ giftedBudget, whoToGift }, clientId) => {
    const users = whoToGift.map(userId => ({
        userId,
        giftedBudget,
        clientId,
    }))
    return { users }
}

// Used for M.
export const convertPenceIntoPounds = pence => (pence ? (pence / PENCE_IN_POUND).toFixed(2) : 0) // Return number of pounds
export const convertPoundsIntoPence = pounds => (pounds ? pounds * PENCE_IN_POUND : 0) // Return number of pence
